var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7143 0H1.2817C0.574554 0 0 0.582589 0 1.29777V16.7022C0 17.4174 0.574554 18 1.2817 18H16.7143C17.4214 18 18 17.4174 18 16.7022V1.29777C18 0.582589 17.4214 0 16.7143 0ZM5.44018 15.4286H2.77232V6.83839H5.4442V15.4286H5.44018ZM4.10625 5.66518C3.25045 5.66518 2.55938 4.97009 2.55938 4.1183C2.55938 3.26652 3.25045 2.57143 4.10625 2.57143C4.95804 2.57143 5.65312 3.26652 5.65312 4.1183C5.65312 4.97411 4.96205 5.66518 4.10625 5.66518ZM15.4406 15.4286H12.7728V11.25C12.7728 10.2536 12.7527 8.97188 11.3866 8.97188C9.99643 8.97188 9.78348 10.0567 9.78348 11.1777V15.4286H7.11562V6.83839H9.675V8.01161H9.71116C10.0688 7.33661 10.9406 6.62545 12.2384 6.62545C14.9384 6.62545 15.4406 8.40536 15.4406 10.7196V15.4286Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinWhite);
export default __webpack_public_path__ + "static/media/linkedinWhite.311e5a16e0749cc64ed3a8a3b10057f4.svg";
export { ForwardRef as ReactComponent };